export default {
    Menu: 'Menu',
    Add: 'Přidat',
    Modify: 'Upravit',
    Delete: 'Smazat',
    Scale: 'Změnit velikost',
    Color: 'Barva',
    Materials: 'Materiály',
    Mesh: 'Síť',
    Size: 'Velikost',
    Details: 'Podrobnosti',
    Quantity: 'Množství',
    AddToCart: 'Přidat do košíku',
    AddToCartTitle: 'Přidat do košíku',
    Cart: 'Košík',
    Total: 'Celkem',
    Subtotal: 'Mezisoučet',
    Shipping: 'Doprava',
    Shape: 'Tvar',
    PickShape: 'Vyberte tvar k přidání na plátno',
    ShapeAdded: 'Tvar přidán. Kliknutím na jiný jej nahradíte.',
    Clipart: 'Ilustrace',
    PickClipart: 'Vyberte ilustraci k přidání na plátno',
    ClipartAdded: 'Ilustrace přidána. Kliknutím na jinou ji nahradíte.',
    SearchClipart: 'Hledat ilustraci…',
    NoClipartFound: 'Nebyla nalezena žádná ilustrace',
    Cliparts: 'Klipart',
    Illustration: 'Ilustrace',
    AiImage: 'Obrázek AI',
    AiImageIntro: 'Popište, co chcete, vyberte formát a získejte 2 návrhy.',
    AiImageFormat: 'Formát',
    AiFormatSquare: 'Čtverec',
    AiFormatPortrait: 'Na výšku',
    AiFormatLandscape: 'Na šířku',
    AiImagePlaceholder: 'Např.: stylizovaná liška, plochý styl, průhledné pozadí…',
    AiGenerate: 'Generovat',
    AiGenerating: 'Generování…',
    AiPickResult: 'Vyberte návrh',
    AiImageAdded: 'Obrázek přidán na plátno',
    AiImageError: 'Generování obrázku se nezdařilo',
    AiNoResult: 'Nebyl vygenerován žádný obrázek',
    AiImageNotInPlan: 'Generování obrázků AI není součástí vašeho tarifu. Aktivujte možnost, abyste ji mohli používat.',
    SearchIllustration: 'Hledat ilustraci…',
    NoIllustrationFound: 'Nebyla nalezena žádná ilustrace',
    IllustrationIntro: 'Vyhledejte vektorové ilustrace k přidání na plátno.',
    IllustrationError: 'Vyhledávání ilustrací se nezdařilo',
    IllustrationNotVector: 'Tento výsledek není použitelný vektor',
    Texts: 'Texty',
    Images: 'Obrázky',
    Colors: 'Barvy',
    ThemeEditDesc: 'Upravte texty, obrázky a barvy motivu.',
    ThemeNotFound: 'Motiv nenalezen.',
    ThemeNoEditable: 'Tento motiv neobsahuje žádné upravitelné prvky.',
    Helpers: 'Pravítka, vodítka a mřížka',
    Rulers: 'Pravítka',
    RulersHint: 'Stupnice v pixelech',
    Guides: 'Vodítka',
    GuidesHint: 'Značky na 25 / 50 / 75 %',
    GridHint: 'Mřížka jako překryv',
    Snapping: 'Přichytávání',
    SnappingHint: 'Zarovná ke středu / mřížce / jiným objektům',
    LeaveConfirm: 'Opravdu chcete přijít o své změny?',
    Products: 'Produkty',
    Customization: 'Personalizace',
    BackToCustomizationType: 'Typ personalizace',
    SaveNoChanges: 'Žádné změny k uložení',
    ChooseCategory: 'Vyberte kategorii',
    SelectProduct: 'Vyberte produkt',
    Loading: 'Načítání',
    ProofLogoTooLarge: 'Logo je příliš velké (maximálně 500 KB).',
    ProofLogoInvalidType: 'Nepodporovaný formát obrázku.',
    ProofLogoImported: 'Logo importováno.',
    ProofLogoImportFailed: 'Import loga se nezdařil.',
    YouHaveProjects: 'Máte {count} rozpracovaný(ch) projekt(ů)',
    ResumeProject: 'Pokračovat v projektu',
    ResumeProjectHint: 'Pokračujte tam, kde jste přestali.',
    YourProjects: 'Vaše rozpracované projekty',
    OpenProject: 'Otevřít tento projekt',
    NoProjects: 'Žádné rozpracované projekty.',
    AppUpdating: 'Aktualizace aplikace…',
    DraftRestored: 'Koncept obnoven',
    SaveExpiredTitle: 'Uložení vypršelo',
    SaveExpiredMessage: 'Toto uložení vypršelo nebo již není dostupné.',
    Continue: 'Pokračovat',
    PhotoFramePickShape: 'Vyberte rámeček',
    PhotoFramePlacePhoto: 'Umístěte a upravte fotku',
    PhotoFrameChangePhoto: 'Změnit fotku',
    PhotoFrameDropTitle: 'Přetáhněte sem fotku',
    PhotoFrameDropSub: 'nebo klikněte pro nahrání',
    Rotation: 'Otočení',
    Reset: 'Obnovit',
    ProofLogoTitle: 'Logo náhledu k tisku',
    ProofLogoUseSite: 'Ponechat logo {site}',
    ProofLogoUseMine: 'S vlastním logem',
    ProofLogoUseMineDesc: 'Pouze na náhledu, ne na tiskových souborech.',
    ProofLogoNone: 'Bez loga',
    ProofLogoDropTitle: 'Nahrajte své logo',
    ProofLogoDropHint: 'PNG, JPG, WebP, SVG',
    LoadingValidation: 'Ověřování objednávky',
    LoadingStepScreenshots: 'Generování náhledů',
    LoadingStepPrintFile: 'Generování tiskových souborů',
    LoadingStepUpload: 'Nahrávání na server',
    LoadingStepSave: 'Ukládání konfigurace',
    LoadingGraduation: 'Načítání stupnice',
    OptimizingImage: 'Optimalizace obrázku',
    LoadingScene: 'Načítání scény',
    LoadingStepZip: 'Vytváření zipu',
    LoadingProduct: 'Načítání produktu',
    Category: 'Kategorie',
    Product: 'Produkt',
    Summary: 'Souhrn',
    Zone: 'Zóna',
    SelectZone: 'Vyberte zónu',
    SelectAZone: 'Vyberte zónu',
    Undo: 'Zpět',
    Redo: 'Znovu',
    Recenter: 'Vycentrovat pohled',
    HelpersIntro: 'Okraje zón, mřížka, pravítka a vodítka na 2D plátně.',
    ShowZoneBordersHint: 'Rámečky zón na hlavním plátně',
    Save: 'Uložit',
    Saving: 'Ukládání',
    Grid: 'Mřížka',
    SwitchTo3D: 'Přepnout na 3D',
    PrintZone: 'Oblast tisku',
    ViewModeSwitch: 'Režim zobrazení',
    ViewMode3D: '3D',
    ViewMode2D: '2D',
    ViewModeUI: 'UI',
    ViewModeDual: 'Duální',
    ShowZoneBorders: 'Zobrazit obrysy zón',
    ShowZoneBordersHelp: 'Zobrazí/skryje přerušovaný obrys a popisek zón na 2D plátně.',
    ManageElements: 'Spravovat prvky',
    StartWithTheme: 'Začít s motivem',
    Customize: 'Personalizovat',
    FromThemeLibrary: 'Z naší knihovny motivů',
    StartFromScratch: 'Začít od nuly',
    Or: 'nebo',
    PreviousCreations: 'Předchozí výtvory',
    WithModel: 'Se šablonou',
    Search: 'Hledat',
    SubCategory: 'Podkategorie',
    Next: 'Další',
    Previous: 'Předchozí',
    Validate: 'Potvrdit',
    DownloadMyProject: 'Stáhnout můj projekt',
    EditThemeColors: 'Upravit barvy prvků',
    AddPattern: 'Přidat pozadí',
    EditGraduation: 'Upravit přechod',
    Pattern: 'Pozadí',
    PatternHint: 'Vzor se opakuje po celé oblasti personalizace. Jeho barvy lze upravit.',
    SearchTheme: 'Hledat motiv (název nebo štítek)',
    Theme: 'Motiv',
    Graduation: 'Přechod',
    Graduation_s: 'Přechod(y)',
    ErrorOccurred: 'Došlo k chybě.',
    ReloadPage: 'Znovu načtěte stránku.',
    LoadingCategories: 'Načítání kategorií',
    ShowAll: 'Zobrazit vše',
    Categories: 'Kategorie',
    ComingSoon: 'Již brzy',
    DropImageHere: 'Přetáhněte sem obrázek',
    ReleaseToImport: 'Uvolněte pro import',
    OrClickToBrowse: 'nebo klikněte pro procházení',
    AcceptedFormats: 'PNG, JPG, SVG, PDF, AI',
    VectorRecommendedForMethod:
        'Tato tisková metoda pracuje s definovanými barvami. Pro optimální výsledek doporučujeme vektorové soubory.',
    SearchInPhotoGallery: 'Hledat v naší fotogalerii',
    QrCode: 'QR kód',
    QrCodeContent: 'Obsah (URL, text, e-mail…)',
    QrCodePlaceholder: 'https://priklad.com',
    QrCodeForeground: 'Barva QR',
    QrCodeBackground: 'Pozadí',
    QrCodeTransparentBg: 'Průhledné pozadí',
    QrCodeErrorLevel: 'Tolerance chyb',
    QrCodeErrorL: '7 % (nízká hustota)',
    QrCodeErrorM: '15 % (standard)',
    QrCodeErrorQ: '25 %',
    QrCodeErrorH: '30 % (vysoká)',
    QrCodeEmptyPreview: 'Zadejte obsah pro náhled',
    QrCodeRequired: 'Obsah QR kódu je povinný.',
    QrCodeInvalidUrl: 'Zadejte platnou URL QR kódu (http:// nebo https://).',
    QrCodeAdd: 'Přidat QR kód',
    QrCodeEditOnlyColors:
        'Po vytvoření QR kódu lze změnit pouze barvy. Chcete-li změnit obsah, smažte jej a vytvořte nový.',
    ImageQualityGood: 'Dobré rozlišení',
    ImageQualityMedium: 'Střední rozlišení',
    ImageQualityLow: 'Nízké rozlišení – zvětšete obrázek nebo jej zmenšete na plátně',
    LowQualityAlertTitle: 'Pozor',
    LowQualityAlertMessage:
        'Váš návrh obsahuje obrázky nízké kvality nebo příliš zvětšené oproti původnímu rozlišení. Opravte návrh, nebo přijměte riziko pixelizace při tisku.',
    LowQualityAlertHint: 'Práh nízkého rozlišení:',
    LowQualityAcceptRisk: 'Přijímám riziko pixelizace u svých obrázků nízké kvality',
    Preview: 'Náhled',
    Bold: 'Tučné',
    Italic: 'Kurzíva',
    Underline: 'Podtržené',
    FontSize: 'Velikost',
    SelectFont: 'Vyberte písmo',
    UploadFont: 'Nahrát vlastní písmo',
    UploadFontHint: 'TTF nebo OTF · max. 5 MB',
    CustomFontBadge: 'vlastní',
    CustomFontImported: 'Písmo importováno.',
    CustomFontFormatError: 'Nepodporovaný formát (pouze TTF nebo OTF).',
    CustomFontTooLarge: 'Písmo je příliš velké (maximálně 5 MB).',
    CustomFontImportFailed: 'Import písma se nezdařil.',
    CustomFontRemoved: 'Písmo odstraněno.',
    RecentFonts: 'Nedávné',
    Clear: 'Vymazat',
    TextColor: 'Barva textu',
    TextOutline: 'Obrys',
    AddOutline: 'Přidat obrys',
    RemoveOutline: 'Odebrat obrys',
    PickColor: 'Vyberte barvu',
    PickThemeCategory: 'Vyberte kategorii pro prozkoumání motivů',
    NoThemeInCategory: 'V této kategorii není žádný motiv',
    ThemePreviewLabel: 'Náhled motivu',
    PickAnotherTheme: 'Vyberte jiný motiv',
    Keep: 'Zachovat',
    LoadingThemes: 'Načítání motivů',
    LoadingPatterns: 'Načítání pozadí',
    EditableThemeColors: 'Upravitelné barvy prvků',
    PickAColor: 'Vyberte barvu',
    SelectALayout: 'Vyberte šablonu',
    CreateLayer: 'Vytvořit prvek',
    LastDownloads: 'Poslední stažení',
    Cancel: 'Zrušit',
    Back: 'Zpět',
    BackToProvider: 'Zpět na {provider}',
    LayerNotFound: 'Prvek nebyl nalezen',
    ChangeImage: 'Změnit obrázek',
    ChangePattern: 'Změnit pozadí',
    Resize: 'Změnit velikost',
    RemoveBackground: 'Odstranit pozadí',
    Processing: 'Zpracování…',
    AddFilter: 'Přidat filtr',
    PhotoCredit: 'Foto od {author} na {provider}',
    PhotoBy: 'Foto od',
    On: 'na',
    LinkRedirectionWarning: 'Tento odkaz vás přesměruje na tento web',
    LoadMore: 'Načíst více',
    EditLayer: 'Upravit prvek',
    Import: 'Importovat',
    FromYourDevice: 'Z vašeho zařízení',
    FromImageGallery: 'Z galerie obrázků',
    NoGraduationsAvailable: 'Žádný přechod není k dispozici',
    Confirm: 'Potvrdit',
    CustomizeProduct: 'Personalizujte svůj produkt',
    WriteYourText: 'Napište svůj text sem',
    Text: 'Text',
    Image: 'Obrázek',
    DesignSummary: 'Shrnutí vašeho návrhu',
    AddOptions: 'Přidat možnosti',
    TermsOfSale: 'Všeobecné obchodní podmínky',
    TOSMessage:
        'Potvrzuji, že můj výtvor je v souladu s [Všeobecnými obchodními podmínkami](#), zejména s článkem 8 - Duševní vlastnictví',
    IValidateMyCreation: 'Potvrzuji svůj výtvor',
    FunctionalityNotAvailable: 'Funkce není k dispozici',
    Lock: 'Uzamknout',
    Unlock: 'Odemknout',
    AddLayer: 'Přidat prvek',
    LayerSectionTemplates: 'Šablony',
    LayerSectionText: 'Text a data',
    LayerSectionImages: 'Obrázky',
    LayerSectionDecor: 'Dekorace',
    LayerSectionTools: 'Nástroje',
    DragLayersToReorder: 'Přetažením vrstev změníte pořadí',
    PleaseAgreeTOS: 'Pro potvrzení výtvoru přijměte všeobecné podmínky.',
    ErrorExportPrintFile: 'Při exportu tiskového souboru došlo k chybě.',
    ErrorExportProofFile: 'Při exportu náhledu ke schválení došlo k chybě.',
    ErrorAddToCart: 'Při přidávání do košíku došlo k chybě: ',
    Gabarit: 'Šablona',
    FicheTechnique: 'Technický list',
    GeneratingPrintFile: 'Generování tiskového souboru…',
    GeneratingProofFile: 'Generování náhledu ke schválení…',
    LeaveCustomizer: 'Opustit konfigurátor',
    LeaveManager: 'Opustit správce prvků',
    ChangeProductTitle: 'Váš výtvor bude smazán.',
    ChangeProductConfirm: 'Změna produktu trvale smaže váš výtvor, jste si jistí?',
    Duplicate: 'Duplikovat',
    LoadingTheme: 'Načítání motivu',
    LoadingPattern: 'Načítání pozadí',
    Expand: 'Zvětšit',
    Shrink: 'Zmenšit',
    TiltLeft: 'Naklonit doleva',
    TiltRight: 'Naklonit doprava',
    Rotate: 'Otočit',
    Move: 'Přesunout',
    Reposition: 'Změnit polohu',
    MoveUp: 'Přesunout nahoru',
    MoveDown: 'Přesunout dolů',
    MoveLeft: 'Přesunout doleva',
    MoveRight: 'Přesunout doprava',
    NoCustomization: 'Na produktu není žádná personalizace.',
    MissingCustomization: 'Chybějící personalizace',
    SelectGraduation: 'Vyberte přechod',
    ProofTitle: 'Náhled ke schválení',
    ProofDesignTitle: 'Personalizace 2D',
    ProofScreenshotsTitle: 'Pohledy 3D',
    ProofSelectedInksTitle: 'Vybrané barvy',
    Warning: 'Pozor',
    SelectZoneBeforeTheme: 'Před výběrem motivu vyberte zónu.',
    ThemeTooManyElements: 'Motiv obsahuje příliš mnoho prvků. Vyberte jiný',
    Error: 'Chyba',
    ProductNotFound: 'Produkt nenalezen',
    ProductNotFoundMessage: 'Produkt nenalezen, budete přesměrováni na domovskou stránku.',
    NoCategoryAvailable: 'Žádná kategorie není k dispozici',
    CategoryNotFound: 'Kategorie nenalezena',
    CategoryNotFoundMessage: 'Kategorie nenalezena, budete přesměrováni na domovskou stránku.',
    Unavailable: 'Nedostupné',
    SavedConfigurations: 'Uložené konfigurace',
    YourSavedConfigurations: 'Vaše uložené konfigurace',
    NoSavedConfigurations: 'Pro tento produkt nejsou uloženy žádné konfigurace',
    ConfigurationName: 'Název konfigurace',
    Created: 'Vytvořeno',
    Expires: 'Vyprší',
    Load: 'Načíst',
    ConfirmDeleteConfiguration: 'Opravdu chcete smazat tuto konfiguraci?',
    Close: 'Zavřít',
    Step: 'Krok',
    CustomizeProductDesc: 'Vyberte, jak začít: volná tvorba nebo z motivu navrženého níže.',
    StartFromScratchDesc: 'Prázdné plátno pro přidání textů, obrázků a tvarů, bez vnucené šablony.',
    ChooseProductDesc: 'Vyberte produkt k personalizaci.',
    PrintMethod: 'Metoda tisku',
    ChoosePrintMethod: 'Vyberte svou metodu',
    ChoosePrintMethodDesc: 'Vyberte metodu tisku pro tento produkt. Tato volba je pro tuto personalizaci konečná.',
    Digital: 'Digitální',
    ScreenPrinting: 'Sítotisk',
    LaserEngraving: 'Laserové gravírování',
    Embroidery: 'Výšivka',
    RestrictedToPalette: 'Barvy omezené na paletu',
    ChooseInks: 'Vyberte své barvy',
    ChooseThreads: 'Vyberte své nitě',
    AppliesToZone: 'Zóna: {zone}',
    Ink: 'Barva',
    Thread: 'Nit',
    InkOverride: 'Vynutit barvu',
    ThreadOverride: 'Vynutit nit',
    SuggestInks: 'Navržené barvy',
    SuggestThreads: 'Navržené nitě',
    RecommendColorsFromImage: 'Doporučit barvy z obrázku',
    NoColorSuggestion: 'Pro tento obrázek není žádný návrh barev.',
    InkAssistantHelp: 'Tato metoda používá paletu {count} pevných barev.',
    InkAssistantQuestion: 'Jak chcete definovat své barvy?',
    InkAssistantUpload: 'Pomozte mi najít mé barvy',
    InkAssistantUploadDesc: 'Importujte svůj obrázek, logo nebo vzor – automaticky rozpoznáme nejbližší barvy palety.',
    InkAssistantManual: 'Vybírám barvy ručně',
    InkAssistantManualDesc: 'Vyberte každou barvu jednu po druhé z palety.',
    InkAssistantAnalyzing: 'Analýza vašeho obrázku…',
    InkChoiceModifiableHint: 'Tuto volbu lze kdykoli změnit.',
    InkAssistantResultDesc: 'Zde jsou barvy palety nejbližší vašemu obrázku.',
    InkDuplicateWarning:
        'Tato barva je již vybrána pro jinou barvu / nit. Její druhé vybrání barvy trvale sloučí. Jste si jistí?',
    Selected: 'Vybráno',
    VectorizeImage: 'Vektorizovat obrázek',
    Vectorizing: 'Vektorizace…',
    VectorizePreviewTitle: 'Výsledek vektorizace',
    VectorizeIntro: 'Obrázek bude převeden na vektor a omezen na vybrané barvy. Potvrďte výsledek pro jeho použití.',
    VectorizeApply: 'Použít vektor',
    VectorizeConsent: 'Rozumím, že jsem zodpovědný za kontrolu výsledku vektorizace a že tisk jej bude odrážet.',
    VectorizeThreshold: 'Práh (detail / pozadí)',
    VectorizeThresholdHint:
        'Upravte práh pro doladění: nižší odstraní více světlého pozadí (perokresba); vyšší zachová více světlých oblastí.',
    VectorizeCancel: 'Zrušit',
    VectorizeFailed: 'Vektorizace se nezdařila. Zkuste to znovu nebo změňte obrázek.',
    Before: 'Před',
    After: 'Po',
    VariableText: 'Proměnný text',
    VariableTextIntro:
        'Tato funkce se podobá hromadné korespondenci a umožňuje získat produkt vytištěný v jednom unikátním kuse pro každý text; množství se automaticky vypočítá pro váš košík.',
    VariableTextData: 'Data (jeden řádek = jeden kus)',
    VariableTextPlaceholder: 'Jean Dupont\nMarie Martin\nPaul Bernard',
    VariableTextImport: 'Importovat CSV / Excel',
    SessionImages: 'Importované obrázky',
    Accept: 'Přijmout',
    UploadConsentMessage:
        'Potvrzuji, že žádný z mých souborů neporušuje platné zákony, autorská práva ani práva třetích stran.',
    VariableTextNoData: 'Pro náhled přidejte alespoň jeden řádek.',
    VdpFields: 'Proměnná pole',
    VdpFieldName: 'Název pole',
    VdpPlace: 'Umístit',
    VdpPlaced: 'Umístěno',
    VdpAddField: 'Přidat pole',
    VdpAddRow: 'Přidat řádek',
    VdpLine: 'Řádek',
    VdpEnterData: 'Zadat má data',
    Done: 'Hotovo',
    VdpFieldStyle: 'Styl pole',
    VdpFirstRowHeader: '1. řádek = záhlaví (názvy polí)',
    VdpQuantity: 'Množství: {qty}',
    VdpQuantityHint: 'Množství je dáno počtem řádků vašeho proměnného textu.',
    VariableTextOnlyOne: 'Pouze jedno pole proměnného textu na výtvor.',
    VariableTextEmptyFile: 'Prázdný soubor nebo bez použitelného sloupce.',
    VariableTextImportError: 'Tento soubor nelze přečíst. Použijte CSV nebo vložte text.',
    VariableTextExcelUnavailable: 'Čtení Excelu není k dispozici. Exportujte do CSV nebo vložte text.',
    InkAuto: 'Auto',
    PreflightScreenMissingInks: 'Vybrané barvy: {chosen}/{required}. Před potvrzením vyberte všechny barvy.',
    PreflightScreenColorCount: 'Sítotisk: váš výtvor je omezen na {count} barvu/barev.',
    PreflightMinStroke: 'Doporučená minimální tloušťka čáry: {mm} mm. Tenčí čáry se mohou špatně tisknout.',
    PreflightMinFont: 'Doporučená minimální velikost písma: {pt} pt.',
    PreflightLaserMonochrome: 'Laserové gravírování: konečný výsledek bude jednobarevný.',
    More: 'Více',
    All: 'Vše',
    AllCategories: 'Všechny kategorie',
    SearchCategory: 'Hledat kategorii…',
    NoProductAvailable: 'V této kategorii nejsou žádné produkty.',
    ChooseProductTitle: 'Vyberte svůj produkt k personalizaci',
    PrintMethodQuestion: 'Jak chcete potisknout svůj {product}?',
    PrintMethodIntro: 'Každá metoda má své silné stránky a omezení — určuje barvy a povrchové úpravy dostupné poté.',
    StartLabel: 'Výchozí bod',
    StartTitle: 'Začněte od motivu nebo prázdné stránky',
    StartIntro: 'Motiv = hotový návrh k úpravě (nejrychlejší). Prázdná stránka = plná kontrola.',
    StepProduct: 'Produkt',
    StepMethod: 'Metoda',
    StepStart: 'Start',
    StepDesign: 'Návrh',
    ChangeTheme: 'Změnit motiv',
    BackToTheme: 'Zpět na motiv',
    Recent: 'Nedávné',
    WhiteNotPrintable: 'Bílou nelze tisknout (průhledná).',
    LoginToSave: 'Přihlaste se, abyste své návrhy našli ve svém účtu.',
    Login: 'Přihlásit se',
    LoggingIn: 'Přihlašování…',
    ContinueWithoutAccount: 'Pokračovat bez účtu',
    SaveEmailPlaceholder: 'Vaše e-mailová adresa',
    SaveEmailHint: 'Obdržíte odkaz pro obnovení projektu (uchováno 30 dní).',
    SaveConfirmTitle: 'Projekt uložen',
    SaveConfirmMessage: 'Váš projekt byl uložen. Právě jsme vám poslali e-mail s odkazem pro jeho obnovení.',
    DisableEmbroideryEffect: 'Vypnout efekt výšivky',
    AddThread: 'Přidat nit',
    RemoveThread: 'Odebrat nit',
    VectorizeDenoise: 'Snížit šum',
    VectorizeDenoiseHint: 'Odstraní skvrny a drobné nežádoucí tečky.',
    VectorizeSmoothing: 'Vyhlazení',
    VectorizeSmoothingHint: 'Zaoblí obrysy (méně rohů).',
    ZoomIn: 'Přiblížit',
    ZoomOut: 'Oddálit',
    Fit: 'Přizpůsobit',
    Apply: 'Použít',
    Edit: 'Upravit',
    Support: 'Podpora',
    VectorizeAcknowledge:
        'Beru na vědomí, že jsem odpovědný za kontrolu výsledku vektorizace a že tisk jej bude odrážet.',
    Crop: 'Oříznout',
    Font: 'Písmo',
    Style: 'Styl',
    Outline: 'Obrys',
    Steps: 'Kroky',
    Tools: 'Nástroje',
    ThemeColors: 'Barvy',
    Minimize: 'Minimalizovat',
    MoveLayerUp: 'Posunout vrstvu nahoru',
    MoveLayerDown: 'Posunout vrstvu dolů',
    DragLayer: 'Přetažením změníte pořadí',
    NoResult: 'Žádný výsledek',
    SearchElement: 'Hledat prvek…',
    ExpertMode: 'Expertní režim',
    Finish: 'Dokončit',
    ChooseImageOrPhoto: 'Vyberte obrázek nebo fotografii',
    WizardIntro: 'Postupujte podle kroků a vytvořte personalizovaný návrh za 1 minutu.',
    WizardIntroExpert: 'Chcete více volnosti? Přepněte do expertního režimu.',
    ClickToChooseImage: 'Klikněte sem pro výběr obrázku nebo fotografie',
    ChooseCategoryDesc: 'Vyberte skupinu produktů a začněte.',
    SelectProductDesc: 'Vyberte produkt a začněte…',
    FinalReview: 'Poslední krok',
    StartWithThemeDesc: 'Začněte z předpřipraveného návrhu.',
    WithModelDesc: 'Vyberte hotovou šablonu.',
    ExpertModeConfirmTitle: 'Expertní režim',
    ExpertModeConfirmMsg:
        'Přepnutí do expertního režimu je konečná volba. Tento režim je o něco složitější na použití, ale umožňuje přidávat a upravovat prvky bez omezení.',
    ExpertModeHint: 'Dokončete svůj návrh bez omezení – přidejte texty a fotografie podle libosti.',
    VariableData: 'Proměnná data',
    PhotoFrame: 'Fotorámeček',
    PhotoFrameHint: 'Vyberte tvar a poté do něj vložte fotografii.',
    PhotoFrameChooseShape: '1. Tvar rámečku',
    PhotoFrameChangeShape: 'Změnit tvar',
    PhotoFramePickPhoto: 'Vyberte fotografii',
    FromLibrary: 'Z knihovny',
    VdpMaxRowsReached: 'Dosažen maximální počet kusů',
    VdpImportTruncated: 'Import omezen na dostupné množství',
    LetterSpacing: 'Prostrkání písmen',
    OutlineActive: 'Obrys zapnut',
    OutlineThickness: 'Tloušťka obrysu',
    AlignLeft: 'Zarovnat vlevo',
    AlignCenter: 'Na střed',
    AlignRight: 'Zarovnat vpravo',
    Uppercase: 'Velká písmena',
    TextFormatting: 'Formátování',
    FontSizeLabel: 'Velikost písma',
    SelectionActions: 'Akce výběru',
    DragToMove: 'Přetažením přesunete',
    DragToResize: 'Přetažením změníte velikost',
    DragToRotate: 'Přetažením otočíte',
    MoveUpOneLevel: 'O úroveň výš',
    MoveDownOneLevel: 'O úroveň níž',
    BringToFront: 'Přenést do popředí',
    Front: 'Popředí',
    SendToBack: 'Přenést do pozadí',
    BackgroundNeverUnderPattern: 'Pozadí (nikdy pod vzorem pozadí)',
    EyedropperColor: 'Kapátko barvy',
    PresetColors: 'Přednastavené barvy',
    RecentColors: 'Nedávné barvy',
    Palette: 'Paleta',
    HexValue: 'Hodnota hex',
    AiResultsHint: 'Všechny návrhy najdete na kartě Obrázek',
    Notifications: 'Oznámení',
    Zoom: 'Přiblížení',
    GuidedCustomization: 'Řízené přizpůsobení',
    Actions: 'Akce',
    InkAssistantYourChoice: 'Vybrali jste:',
    InkAssistantCorrectQuestion: 'Chcete tuto volbu upravit?',
    '': ''
};
